import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchApprovalCounts } from 'src/redux/slices/pending-counts';

export default function PendingCountsInitializer() {
  const dispatch = useDispatch();

  const { isAuthenticated, user } = useSelector((state) => state.auth);

  useEffect(() => {
    //  Fix ESLint consistent-return
    if (!isAuthenticated || !user?.userId) {
      console.log("Existed without executing")
      return () => { };
    }

    dispatch(fetchApprovalCounts());

    return () => { }; // for ESLint consistent-return
  }, [dispatch, isAuthenticated, user?.userId]);

  return null;
}